import React from 'react'
import PropTypes from 'prop-types';

function MediaTeaser({ option, indexItem }) {

    return (
        <div className="o-layout__item  u-1/2  u-1/1@s" key={indexItem}>
            <div className="o-page-wrap">
                <div className="o-component-wrapper">
                    <section className="c-media-teaser  ">
                        <div className="c-media-teaser__media">
                            <img className="c-media-teaser__image  js-object-fit" src={process.env.PUBLIC_URL + option.routeImage} sizes="100vw" alt={option.textAlt != '' ? option.textAlt : ''} />
                        </div>
                        <div className="c-media-teaser__caption">
                            <h3 className="c-media-teaser__title">{option.title != '' ? option.title : ''}</h3>
                            <div className="c-media-teaser__pretitle">{option.pretitle_1 != '' ? option.pretitle_1 : ''}</div>
                            <div className="c-media-teaser__pretitle">{option.pretitle_2 != '' ? option.pretitle_2 : ''}</div>
                            <div className="c-media-teaser__body">
                                <p>{option.body != '' ? option.body : ''}</p>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    )
}

export default MediaTeaser;